<template>
  <v-container class="error_page" fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm6 md3>
        <v-card class="elevation-12" color="error">
          <v-card-text class="px-2">
            <div class="error_page__text">
              You don’t have access to this page. Contact the manager or the admin.
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="secondary" block @click="$router.go(-1)">Back</v-btn>
            <v-btn color="secondary" block @click="$router.push('/')">Home</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'ErrorPage',
  }
</script>
